@if(wizardStore.A().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-input
      [label]="translationKey + 'projectOwnerFullName'"
      inputFormControlName="projectOwnerFullName"
      [inputFormControl]="formGroup!.controls.projectOwnerFullName"
    />
    <app-validated-dropdown
      [label]="'general.legalForm'"
      inputFormControlName="legalForm"
      [inputFormControl]="formGroup!.controls.legalForm"
      [loading]="!genericDataStore.allLoaded()"
      [optionsStamp]="genericDataStore.companyTypesEntities().length"
    >
      @for (companyType of genericDataStore.companyTypesEntities(); track
      $index) {
      <option [value]="companyType.id">
        {{ companyType.localized | getLocalized }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="'general.ownershipStructure'"
      inputFormControlName="ownershipStructure"
      [inputFormControl]="formGroup!.controls.ownershipStructure"
      [loading]="!genericDataStore.allLoaded()"
      [optionsStamp]="genericDataStore.ownershipStructureEntities().length"
    >
      @for (ownershipStructure of genericDataStore.ownershipStructureEntities();
      track $index) {

      <option [value]="ownershipStructure.id">
        {{
          ownershipStructure.id
            | baseEnumItemById
              : "generic.ownershipStructure"
              : genericDataStore.ownershipStructureEntities()
            | translate
        }}
      </option>
      }
    </app-validated-dropdown>

    <div [formGroupName]="'projectOwner'">
      <app-title-name-card
        [formGroup]="$any(formGroup!.controls.projectOwner)"
        [title]="translationKey + 'projectManager'"
      />
      <div class="row flex-align-center">
      </div>
    </div>

    <app-validated-input
      [label]="'general.contactEmail'"
      inputFormControlName="contactEmail"
      [inputFormControl]="formGroup!.controls.contactEmail"
    />

    <app-validated-checkbox
      [label]="translationKey + 'allInfoIsValid'"
      inputFormControlName="validInformation"
      [inputFormControl]="formGroup!.controls.validInformation"
    />

    <hr />
    <div>
      <label class="section-title">{{
        translationKey + "responsiblePersons" | translate
      }}</label>
    </div>

    <div [formGroupName]="'projectOwnerAdministrator'">
      <app-title-name-card
        [formGroup]="$any(formGroup!.controls.projectOwnerAdministrator)"
        [title]="translationKey + 'poAdminManager'"
      />
      <div class="row flex-align-center">
        <div class="col-auto my-2">
          <app-validated-input
            [label]="'general.email'"
            inputFormControlName="email"
            [inputFormControl]="formGroup!.controls.projectOwnerAdministrator.controls.email"
          />
        </div>
      </div>
    </div>

    <div [formGroupName]="'projectProfileOperatorFirst'">
      <app-title-name-card
        [formGroup]="$any(formGroup!.controls.projectProfileOperatorFirst)"
        [title]="translationKey + 'poProfileManager'"
      />
      <div class="row flex-align-center">
        <div class="col-auto my-2">
          <app-validated-input
            [label]="'general.email'"
            inputFormControlName="email"
            [inputFormControl]="formGroup!.controls.projectProfileOperatorFirst.controls.email"
          />
        </div>
      </div>
    </div>

    <div [formGroupName]="'projectProfileOperatorSecond'">
      <app-title-name-card
        [formGroup]="$any(formGroup!.controls.projectProfileOperatorSecond)"
        [title]="translationKey + 'poProfileManager'"
      />
      <div class="row flex-align-center">
        <div class="col-auto my-2">
          <app-validated-input
            [label]="'general.email'"
            inputFormControlName="email"
            [inputFormControl]="formGroup!.controls.projectProfileOperatorSecond.controls.email"
          />
        </div>
      </div>
    </div>

    <app-validated-number-input
      [label]="translationKey + 'TEAORNumber'"
      inputFormControlName="projectTEAORNumber"
      [inputFormControl]="formGroup!.controls.projectTEAORNumber"
    />

    <hr />

    <div>
      <label class="section-title">{{
        translationKey + "poLastYearReport" | translate
      }}</label>
    </div>

    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'lastFinancialYearsReport'"
      [formControls]="formGroup!.controls.lastFinancialReports"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />

    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'twoFinancialYearsReport'"
      [formControls]="formGroup!.controls.secondYearFinancialReports"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />

    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'threeFinancialYearsReport'"
      [formControls]="formGroup!.controls.thirdYearFinancialReports"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />
    <hr />
    <div>
      <label class="section-title">{{
        translationKey + "projectShortDescription" | translate
      }}</label>
    </div>
    <app-validated-textarea
      [label]="translationKey + 'projectShortDescriptionInfo'"
      inputFormControlName="projectDescription"
      [inputFormControl]="formGroup!.controls.projectDescription"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
